// import React from "react";
// import CalvinLogo from "../../assets/Images/Calvin-Group-Logo-A2.svg";
// import RightIcon from "../../assets/Images/rightIcon.svg";
// import { FaStar, FaStarHalfAlt, FaPlus } from "react-icons/fa";

// const ListingCard = () => {
//   return (
//     <div className="border shadow-md rounded-t-lg w-full mx-auto">
//       {/* Asking Price Section */}
//       <div className="bg-[#F2F2F2] px-[17px] pt-[8px] pb-[16px]">
//         <div className="flex justify-between items-center">
//           <div className="text-[#161412] text-[16px] font-normal">ASKING</div>
//           <button className="text-[#FEBA06] text-xl font-bold">
//             <FaPlus className="text-[#FEBA06]" size={"28px"} />
//           </button>
//         </div>
//         <div className="justify-center text-center text-[48px] font-bold text-[#161412] flex items-baseline leading-[35px]">
//           $249,500 <span className="text-lg text-[16px] font-bold text-[#161412]">USD</span>
//         </div>
//       </div>
//       <div className="px-[14px] pt-[15px] pb-[20px]">
//         {/* Listed By Section */}
//         <div>
//           <div className="flex items-center justify-between">
//             <span className="text-[16px] font-bold text-[#161412]">LISTED BY</span>
//             <div className="flex items-center text-yellow-500">
//               <FaStar />
//               <FaStar />
//               <FaStar />
//               <FaStar />
//               <FaStarHalfAlt />
//             </div>
//           </div>
//           <div className="flex items-center mt-2">
//             <img src={CalvinLogo} alt="Calvin Logo" />
//           </div>
//         </div>

//         {/* Contact Section */}
//         <div className="mt-3">
//           <div className="text-[16px] font-bold text-[#161412]">CONTACT</div>
//           <div className="text-[16px] font-normal text-[#161412] ml-[24px]">
//             <p>Mike Pentz</p>
//             <p>+1 (800) 478-5840</p>
//             <p>mike@calvingroupinc.com</p>
//           </div>
//         </div>

//         {/* Location Section */}
//         <div className="mt-3">
//           <div className="text-[16px] font-bold text-[#161412]">LOCATION</div>
//           <div className="text-[16px] font-normal text-[#161412] ml-[24px]">
//             <p>1110 Street St</p>
//             <p>Anycity, US USA 12345</p>
//           </div>
//         </div>

//         {/* Footer Section */}

//         <div className="flex flex-col items-center sm:items-end mt-[60px]">
//           <div className="text-[#161412] text-[16px] flex">
//             <img src={RightIcon} alt="Right Icon" className="mr-1" />
//             <b>Calvin Group Inc | </b> Grafton, OH
//           </div>
//           <div className="text-[#161412] text-[16px] font-bold">+1 (800) 888-8888</div>
//           <div className="text-[#161412] text-[16px] font-bold">sales@calvingroupinc.com</div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ListingCard;

// Back Up code
import React, { useEffect, useState } from "react";
import CalvinLogo from "../../assets/Images/Calvin-Group-Logo-A2.svg";
import RightIcon from "../../assets/Images/rightIcon.svg";
import { FaStar, FaStarHalfAlt, FaPlus } from "react-icons/fa";
import { currencyFormat, logoutFun } from "../../utils/helper";
import Icon from "../icon/Icon";
import { addWatchList } from "../../services/vizyBilityServices";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";
import { DarkLogo } from "../../assets/images";
import ReactStars from "react-stars";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ReviewModal from "./ReviewModal";
const ListingCard = ({ data, isLoading }) => {
  const [reviewModel, setReviewModel] = useState(false);
  const { instance, accounts } = useMsal();
  const [cardLoading, setCardLoading] = useState(false);
  const Logout = localStorage.getItem("getAzureUserData") || localStorage.getItem("azuretoken");
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  const [watchList, setWatchList] = useState(data?.is_active_watchlist || false);

  const handleOnPressCall = () => {
    if (data?.dealer?.contact_user?.phone) {
      return `callto:${data?.dealer?.contact_user?.phone}`;
    } else if (data?.dealer?.contact_user?.email) {
      return `mailto:${data?.dealer?.contact_user?.email}`;
    } else {
      return "javascript:void(0)";
    }
  };

  useEffect(() => {
    setWatchList(data?.is_active_watchlist);
  }, [data?.is_active_watchlist]);

  const handelWatchList = () => {
    setCardLoading(true);
    let payload = {
      assetId: data?.id,
      assetAdvertisementId: data?.assetAdvertisementId,
      contactId: azureUserInfo?.ContactId,
    };
    if (watchList) {
      payload = {
        ...payload,
        active: false,
      };
    } else {
      payload = {
        ...payload,
        active: true,
      };
    }

    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addWatchList(payload, header, instance, accounts)
      .then((res) => {
        setWatchList(!watchList);
        setCardLoading(false);
        if (watchList) {
          toast.success("Successfully removed from watchlist!");
        } else {
          toast.success("Successfully added to watchlist!");
        }
      })
      .catch((err) => {
        setCardLoading(false);
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          toast.error("you are logged out, login again to add machines to watchlist.");
          logoutFun(instance);
        } else {
          toast.error(err?.data);
        }
      });
  };

  if (isLoading) {
    return (
      <div className="border shadow-md rounded-t-lg w-full mx-auto p-4">
        {/* Skeleton for Asking Price Section */}
        <div className="bg-[#F2F2F2] h-16 w-full rounded-md animate-pulse"></div>

        {/* Skeleton for Listed By Section */}
        <div className="mt-4 flex items-center">
          <div className="h-6 w-20 bg-gray-300 rounded-md animate-pulse"></div>
          <div className="ml-auto flex space-x-2">
            <div className="h-5 w-5 bg-gray-300 rounded-full animate-pulse"></div>
            <div className="h-5 w-5 bg-gray-300 rounded-full animate-pulse"></div>
            <div className="h-5 w-5 bg-gray-300 rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Skeleton for Contact Section */}
        <div className="mt-4 space-y-2">
          <div className="h-4 w-32 bg-gray-300 rounded-md animate-pulse"></div>
          <div className="h-4 w-48 bg-gray-300 rounded-md animate-pulse"></div>
          <div className="h-4 w-36 bg-gray-300 rounded-md animate-pulse"></div>
        </div>

        {/* Skeleton for Location Section */}
        <div className="mt-4">
          <div className="h-4 w-24 bg-gray-300 rounded-md animate-pulse"></div>
          <div className="h-4 w-40 bg-gray-300 rounded-md animate-pulse mt-2"></div>
        </div>

        {/* Skeleton for Footer Section */}
        <div className="mt-8 flex flex-col items-center space-y-2">
          <div className="h-4 w-48 bg-gray-300 rounded-md animate-pulse"></div>
          <div className="h-4 w-36 bg-gray-300 rounded-md animate-pulse"></div>
          <div className="h-4 w-40 bg-gray-300 rounded-md animate-pulse"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="border shadow-md rounded-t-lg w-full mx-auto">
      {/* Asking Price Section */}
      <div className="bg-[#F2F2F2] px-[17px] pt-[8px] pb-[16px]">
        <div className="flex justify-between items-center">
          <div className="text-[#161412] text-[16px] font-normal">ASKING</div>

          {Logout && (
            <div className="flex justify-center  opacity-100">
              {cardLoading ? (
                <div className="w-[30px] h-[30px] border-2 border-[#feba06] border-dashed rounded-full animate-spin"></div>
              ) : (
                <Icon
                  icon={"HeroHeart"}
                  className={`text-2xl ${
                    watchList ? "fill-[#FEBA06]" : null
                  } w-[30px] h-[30px] text-[#FEBA06] cursor-pointer`}
                  onClick={() => handelWatchList()}
                />
              )}
            </div>
          )}
        </div>
        <div className="justify-center text-center text-[48px] font-bold text-[#161412] flex items-baseline leading-[35px]">
          {data?.advertised_price?.fractional != 0 ? (
            <>
              {data?.advertised_price?.currency?.symbol}
              {currencyFormat(Number(data?.advertised_price?.fractional))}
            </>
          ) : (
            <a
              href={handleOnPressCall()}
              className="bg-[#FEBA06] py-[4px] text-[#161412] text-[20px] md:text-[25px] px-2 rounded disable:hover  "
            >
              Call for Pricing
            </a>
          )}
        </div>
      </div>
      <div className="px-[14px] pt-[15px] pb-[20px]">
        {/* Listed By Section */}
        <div>
          <div className="flex items-center justify-between">
            <span className="text-[16px] font-bold text-[#161412]">LISTED BY</span>
            <div className="flex items-center ">
              <ReactStars
                value={Number(data?.company_info?.company_rating) || 0}
                count={5}
                className="gap-[0px]"
                size={24}
                color2={"#FEBA06"}
                edit={false}
              />

              <div
                className="cursor-pointer text-[16px] font-bold text-[#161412] pl-[5px] underline underline-offset-8"
                data-tooltip-id="button-tooltip"
                data-tooltip-content="Click here to view reviews"
                onClick={() => setReviewModel(true)}
              >{`(${Number(data?.company_info?.number_of_reviews) || 0})`}</div>

              <Tooltip id="button-tooltip" />
            </div>
          </div>
          {reviewModel ? (
            <ReviewModal
              isOpen={reviewModel}
              onClose={() => setReviewModel(false)}
              title="Customer Reviews"
              companyId={data?.company_info?.id}
            />
          ) : null}
          {data?.advertising_type?.trim().toLowerCase() == "consignment" ? (
            <div className="flex items-center mt-2 justify-center">
              <img src={DarkLogo} alt="Calvin Logo" className="max-h-[95px]" />
            </div>
          ) : (
            data?.company_info?.logo?.url && (
              <div className="flex items-center mt-2 justify-center">
                <img src={data?.company_info?.logo?.url} alt="Calvin Logo" className="max-h-[95px]" />
              </div>
            )
          )}
        </div>

        {/* Contact Section */}

        {data?.advertising_type?.trim().toLowerCase() == "consignment" ? (
          <div className="mt-3">
            <div className="text-[16px] font-bold text-[#161412]">CONTACT</div>
            <div className="text-[16px] font-normal text-[#161412] ml-[24px]">
              <p>Paving Market Sales,</p>
              <a href={`callto:${+18888008000}`}>
                <p>+1 (888) 800-8000</p>
              </a>
              <a href={`mailto:sales@pavingmarket.com`}>
                <p>sales@pavingmarket.com</p>
              </a>
            </div>
          </div>
        ) : (
          <div className="mt-3">
            <div className="text-[16px] font-bold text-[#161412]">CONTACT</div>
            <div className="text-[16px] font-normal text-[#161412] ml-[24px]">
              <p>
                {data?.company_info?.contact_user?.first_name} {data?.company_info?.contact_user?.last_name}
              </p>
              <a href={`callto:${data?.company_info?.contact_user?.phone}`}>
                <p>{data?.company_info?.contact_user?.phone}</p>
              </a>
              <a href={`mailto:${data?.company_info?.contact_user?.email}`}>
                <p>{data?.company_info?.contact_user?.email}</p>
              </a>
            </div>
          </div>
        )}

        {/* Location Section */}
        {data?.company_info?.address ? (
          <div className="mt-3">
            <div className="text-[16px] font-bold text-[#161412]">LOCATION</div>
            <div className="text-[16px] font-normal text-[#161412] ml-[24px]">
              <p>{data?.company_info?.address}</p>
            </div>
          </div>
        ) : null}

        {/* Footer Section */}

        <div className="flex flex-col items-center sm:items-end mt-[60px]">
          <div className="text-[#161412] text-[16px] flex">
            <img src={RightIcon} alt="Right Icon" className="mr-1" />
            <b>
              {data?.dealer?.name} {data?.dealer?.address ? `| ${data?.dealer?.address}` : null}
            </b>
          </div>
          <a href={`callto:${data?.dealer?.contact_user?.phone}`}>
            <div className="text-[#161412] text-[16px] font-bold">{data?.dealer?.contact_user?.phone}</div>
          </a>
          <a href={`mailto:${data?.dealer?.contact_user?.email}`}>
            <div className="text-[#161412] text-[16px] font-bold">{data?.dealer?.contact_user?.email}</div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
